export class VersioneDTO {
    public ID: number;
    public ProductName: string;
    public VersionNumber: string;
    public ReleaseNotes: string;
  }